import React from 'react';
import SpaceTreasuryDashboard from './components/SpaceTreasuryDashboard';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <SpaceTreasuryDashboard />
    </ThemeProvider>
  );
}

export default App;
